import React, { useRef } from "react"
import { useUI } from "providers/UIProvider"

import { Box, Image, Flex, Text, Checkbox, Center } from "@chakra-ui/react"
import { useOutsideClick } from "@chakra-ui/react"
import { IDropdownProps, IDropdownItem } from "./DropdownTypes"

import Icon from "components/UI/atoms/Icon"
import Input from "components/UI/atoms/Input"

const Dropdown: React.FC<IDropdownProps> = ({
  selectable,
  searchable,
  selectAll,
  selectedItems,
  handleSelectAll,
  handleSelectItem,
  searchValue,
  searchPlaceholder,
  onSearch,
  selected,
  setSelected,
  items,
  opened,
  toggleOpened,
  excludeSelected,
  styles,
  height,
  width = "100%",
}) => {
  const dropdownElement = useRef<HTMLDivElement>(null)
  useOutsideClick({
    ref: dropdownElement,
    handler: () => toggleOpened(false),
  })

  const { T, modals } = useUI()

  const handleClick = (item: IDropdownItem) => {
    if (!searchable) {
      toggleOpened(false)
    }

    if (item.customHandler) {
      item.customHandler(item)
      return
    }

    if (selectable && setSelected) {
      setSelected(item.value as string)
    }
  }

  let dropdownItems = items

  if (excludeSelected) {
    dropdownItems = items.filter((item) => item.value !== selected?.toString())
  }


  return (
    <Box
      ref={dropdownElement}
      pos="absolute"
      height={height}
      width={width}
      overflowY="auto"
      zIndex={2}
      top="40px"
      as="div"
      bg="white"
      visibility={opened ? "visible" : "hidden"}
      opacity={opened ? 1 : 0}
      transition=".3s ease"
      padding={0}
      borderBottomLeftRadius="20"
      borderBottomRightRadius="20"
      fontSize="base"
      boxShadow="primary"
      {...styles}
    >
      {searchable && onSearch && (
        <Flex
          fontSize="base"
          fontFamily="main"
          height="58px"
          borderBottom="1px solid"
          borderColor="input_border_color_primary"
        >
          <Box height="100%" mr="10px">
            <Input
              id="dropdown-search"
              name="dropdown-search"
              value={searchValue || ""}
              type="string"
              onChange={(e: any) => onSearch(e.target.value)}
              placeholder={searchPlaceholder}
              variant="unbordered"
              size="base"
              icon="search"
              styles={{ width: "100%", height: "100%", padding: "0 0 0 10px" }}
              iconMargin={modals.webReservationsTimesModal.isOpened ? "0px -5.313rem 0px 0px" : ""}
            />
          </Box>
          {modals.webReservationsTimesModal.isOpened ? <></> :
            <Center
              padding="20px 0 20px 20px"
              width="117px"
              height="100%"
              borderLeft="1px solid"
              borderColor="input_border_color_primary"
            >
              <Text mr="10px" fontSize="base" fontWeight="normal">
                {T("general.all")}
              </Text>
              <Checkbox isChecked={selectAll} onChange={handleSelectAll} />
            </Center>
          }
        </Flex>
      )}
      {dropdownItems.map((item, i) =>
        item.customComponent ? (
          <React.Fragment key={item?.id || i}>
            {item.customComponent}
          </React.Fragment>
        ) : (
          <Flex
            as="button"
            width="100%"
            key={item.id || i}
            padding="10px"
            borderBottom={dropdownItems.length - 1 !== i ? "1px solid" : "none"}
            borderColor="dropdown_item_border_color"
            onClick={() => item?.withCheckbox ? handleSelectItem!(item.id as number) : handleClick(item)}
            fontSize="base"
            justifyContent="space-between"
            alignItems="center"
          >
            {item.leftImg && (
              <Flex style={{ flexDirection: "column", width: "70px", alignItems: "center" }}>
                <Image src={item.leftImg} alt="Company" width="45px" />
                <Text marginLeft={item?.name && item.name.includes("ავტოსამრეცხაო") ? "15px" : ""} >{item.name}</Text>
              </Flex>
            )}
            <Text textAlign="center" {...styles}>
              {item.label}
            </Text>
            {item.withCheckbox && handleSelectItem && (
              <Checkbox
                mr="2px"
                isChecked={selectedItems?.includes(item.id as number)}
                pointerEvents="none"
              />
            )}
            {(item.image || item.icon) && (
              <Box>
                {item.image && (
                  <Image
                    src={item.image}
                    alt="Selected Language Flag"
                    w="20px"
                  />
                )}
                {item.icon && (
                  <Icon
                    name={item.icon}
                    iconStyles={{
                      fill: "#046CEC",
                      width: "16px",
                      height: "16px",
                    }}
                  />
                )}
              </Box>
            )}
          </Flex>
        ),
      )}
    </Box>
  )
}

export default Dropdown
